import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import useFetch from "../../../../hooks/useFetch";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import SuccessMessage from "../../../Mensajes/SuccessMessage";
import ServerMessage from "../../../Mensajes/ServerMessage";

/**
 * MarcaUnidadCrear Component
 * @description: Componente que permite agregar un nuevo marcaUnidad.
 * @date 6/12/2022.
 * @param Props Ninguno
 * @returns JSX de la tabla de marcaUnidads.
 */

const MarcaUnidadCrear = () => {
  const [show, setShow] = useState(false);
  const { sendRequest, error, setError, serverMessage, setServerMessage } =
    useFetch();

  //Formulario
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      nombre: "",
      estatus: "1",
    },
  });

  //Función que hace el POST para crear el marcaUnidad.
  const createMarcaUnidad = (data: any) => {
    sendRequest(
      {
        url: `/marca_unidad`,
        method: "POST",
        body: data,
      },
      (variable: any) => {
        setShow(true);
        reset({
          nombre: "",
          estatus: "1",
        });
      }
    );
  };

  return (
    <Container>
      <h1>Agregar marca de unidad</h1>
      {/** Alerta de guardado */}
      {show && (
        <SuccessMessage
          header="Marca agregada"
          body="La marca ha sido agregada de manera correcta."
          onCloseHandler={() => setShow(false)}
        />
      )}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      {/** Error del servidor */}
      {serverMessage && (
        <ServerMessage
          message={serverMessage}
          onCloseHandler={() => setServerMessage(undefined)}
        />
      )}
      {/** Formulario */}
      <Form onSubmit={handleSubmit(createMarcaUnidad)}>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Controller
              name="nombre"
              control={control}
              rules={{
                required: true,
                maxLength: 50,
              }}
              render={({ field }) => {
                return (
                  <Form.Control
                    {...field}
                    onChange={(e) =>
                      field.onChange(e.target.value.toUpperCase())
                    }
                  />
                );
              }}
            />
            {errors.nombre && (
              <Form.Text style={{ color: "red" }}>
                El nombre es obligatorio y no puede ser mayor a 50 caracteres.
              </Form.Text>
            )}
          </Form.Group>
        </Row>

        <Button
          style={{ backgroundColor: "#21618C", borderColor: "white" }}
          type="submit"
        >
          Guardar cambios
        </Button>
      </Form>
    </Container>
  );
};

export default MarcaUnidadCrear;
